export const FIRST_PASS_SENTINEL = 'first-pass';
export const NO_FIELDS_SENTINEL = 'empty';
export const SCROLLED_DEBOUNCE = 200;
export const SETTLED_DEBONCE = 1000;
